/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, state: NonNullable<unknown> }} Explorer_Kanban_State_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Updated \"{name}\" state to \"{state}\"" |
*
* @param {Explorer_Kanban_State_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_state_updated_toast = /** @type {((inputs: Explorer_Kanban_State_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_State_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Etat de "${i?.name}" mis a jour vers "${i?.state}"`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Status "${i?.name}" auf "${i?.state}" aktualisiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiornato lo stato "${i?.name}" a "${i?.state}"`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Состояние "${i?.name}" обновлено до "${i?.state}"`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se actualizó el estado "${i?.name}" a "${i?.state}"`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已将“${i?.name}”状态更新为“${i?.state}”。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」の状態を「${i?.state}」に更新しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.name}" की स्थिति को "${i?.state}" में अपडेट किया गया।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Estado "${i?.name}" atualizado para "${i?.state}"`)
	return /** @type {LocalizedString} */ (`Updated "${i?.name}" state to "${i?.state}"`)
});